"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _HeaderCells = _interopRequireDefault(require("./HeaderCells"));
var _ResultCells = _interopRequireDefault(require("./ResultCells"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査結果検索結果コンポーネント
 *
 * @prop {array} searchResult - 検索結果データ
 * @prop {func} onResultReferClick - 監査結果_参照ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onResultReferOldClick - 監査結果詳細_参照ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onResultRegistClick - 監査結果_登録ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onResultUpdateClick - 監査結果_更新ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onShitekiReferClick - 指摘事項改善_参照ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onShitekiReferOldClick - 指摘事項改善詳細_参照ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onShitekiRegistClick - 指摘事項改善_登録ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onShitekiUpdateClick - 指摘事項改善_更新ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onChiefHyokaReferClick - 被監査部門責任者評価_参照ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onChiefHyokaRegistClick - 被監査部門責任者評価_登録ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {func} onChiefHyokaUpdateClick - 被監査部門責任者評価_更新ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo:number, kansaTgtJigyoId:string }): void
 * @prop {object} paging - ページング情報
 * @prop {number} paging.viewNum - 表示件数の選択値
 * @prop {number} paging.currentPage - 現在ページ位置
 * @prop {object} [scrollTop] - スクロール位置
 * @prop {number} [scrollTop.index] - スクロール位置(行のindex)
 * @prop {number} [scrollTop.scrollY] - スクロール位置(window.scrollY)
 * @prop {bool} [scrollTop.noSticky] - スクロール位置保持時ヘッダ固定されていなかった場合true
 * @prop {func} [onScroll] - スクロール時のイベント <br/>
 *　シグネチャ:( {index:number,scrollY:number,noSticky:bool }): void
 * @prop {func} changePage - pagingのcurrentPageを変更する関数<br/>
 * シグネチャ:(nextPage: number): void
 * @prop {func} changeViewNum - pagingのviewNumを変更する関数<br/>
 * シグネチャ:(viewNum: number): void
 * @prop {func} resetPaging - pagingを初期化する関数<br/>
 * シグネチャ:(): void
 * @prop {bool} soshikiShowAll - 組織名全て表示フラグ
 * @prop {func} changeShowAll - 組織名全て表示変更関数 <br/>
 * シグネチャ:(showAll:bool):void
 * @prop {bool} search - 再検索フラグ
 */
const KansaResultList = function (props) {
  const {
    intl,
    searchResult,
    onResultReferClick,
    onResultReferOldClick,
    onResultRegistClick,
    onResultUpdateClick,
    onShitekiReferClick,
    onShitekiReferOldClick,
    onShitekiRegistClick,
    onShitekiUpdateClick,
    onChiefHyokaReferClick,
    onChiefHyokaRegistClick,
    onChiefHyokaUpdateClick,
    paging,
    resetPaging,
    changePage,
    changeViewNum,
    scrollTop,
    onScroll,
    soshikiShowAll,
    changeShowAll,
    search
  } = props;
  const createRow = data => {
    const {
      kansaTgtNendo,
      kansaTgtJigyoId,
      kansaTgtJigyoNm,
      kansabumonNm,
      hikansabumonNm,
      kansaSoshikiNmFull,
      hikansaSoshikiNmFull,
      btnKansaResultRegist,
      btnKansaResultUpdate,
      btnKansaResultRefer,
      btnKansaResultOld,
      btnShitekiJikoRegist,
      btnShitekiJikoUpdate,
      btnShitekiJikoRefer,
      btnHikansaChiefHyokaRegist,
      btnHikansaChiefHyokaUpdate,
      btnHikansaChiefHyokaRefer,
      kansakekkaCreStsCd
    } = data;
    const kansaInfo = {
      kansaTgtNendo: kansaTgtNendo,
      kansaTgtJigyoId: kansaTgtJigyoId
    };
    const keyPrefix = "".concat(kansaTgtNendo, "-").concat(kansaTgtJigyoId);
    const resultRegister = btnKansaResultRegist && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-result-register"),
      action: "register",
      onClick: () => {
        onResultRegistClick(kansaInfo);
      }
    });
    const resultRefer = btnKansaResultRefer && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-result-refer"),
      action: "detail",
      onClick: () => {
        onResultReferClick(kansaInfo);
      }
    });
    const resultReferOld = btnKansaResultOld && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-result-refer-old"),
      action: "detail",
      onClick: () => {
        onResultReferOldClick(kansaInfo);
      }
    });
    const resultUpdate = btnKansaResultUpdate && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-result-update"),
      action: kansakekkaCreStsCd === _CodeConsts.CODE.KANSA_RSLT_STS.CODE_2 ? 'register' : 'update',
      onClick: () => {
        onResultUpdateClick(kansaInfo);
      }
    });
    const resultActions = [resultRegister, resultRefer, resultReferOld, resultUpdate].filter(Boolean);
    const shitekiRegister = btnShitekiJikoRegist && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-shiteki-register"),
      action: "register",
      onClick: () => {
        onShitekiRegistClick(kansaInfo);
      }
    });
    const shitekiRefer = !btnKansaResultOld && btnShitekiJikoRefer && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-shiteki-refer"),
      action: "detail",
      onClick: () => {
        onShitekiReferClick(kansaInfo);
      }
    });
    const shitekiReferOld = btnKansaResultOld && btnShitekiJikoRefer && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-shiteki-refer-old"),
      action: "detail",
      onClick: () => {
        onShitekiReferOldClick(kansaInfo);
      }
    });
    const shitekiUpdate = btnShitekiJikoUpdate && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-shiteki-update"),
      action: "update",
      onClick: () => {
        onShitekiUpdateClick(kansaInfo);
      }
    });
    const shitekiActions = [shitekiRegister, shitekiRefer, shitekiReferOld, shitekiUpdate].filter(Boolean);
    const chiefHyokaRegister = btnHikansaChiefHyokaRegist && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-chiefhyoka-register"),
      action: "register",
      onClick: () => {
        onChiefHyokaRegistClick(kansaInfo);
      }
    });
    const chiefHyokaRefer = btnHikansaChiefHyokaRefer && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-chiefhyoka-refer"),
      action: "detail",
      onClick: () => {
        onChiefHyokaReferClick(kansaInfo);
      }
    });
    const chiefHyokaUpdate = btnHikansaChiefHyokaUpdate && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "".concat(keyPrefix, "-chiefhyoka-update"),
      action: "update",
      onClick: () => {
        onChiefHyokaUpdateClick(kansaInfo);
      }
    });
    const chiefHyokaActions = [chiefHyokaRegister, chiefHyokaRefer, chiefHyokaUpdate].filter(Boolean);
    const kansaTgtJigyoNmHead = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 0.5
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(kansaTgtJigyoNm))));
    const kansabumonNmHead = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 0.5
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, soshikiShowAll ? _stringUtil.default.emptyToHyphen(kansaSoshikiNmFull) : _stringUtil.default.emptyToHyphen(kansabumonNm))));
    const hikansabumonNmHead = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 0.5
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, soshikiShowAll ? _stringUtil.default.emptyToHyphen(hikansaSoshikiNmFull).split(',').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
      key: "".concat(keyPrefix, "-hikansa-full-").concat(index)
    }, line, /*#__PURE__*/_react.default.createElement("br", null))) : _stringUtil.default.emptyToHyphen(hikansabumonNm).split(',').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
      key: "".concat(keyPrefix, "-hikansa-").concat(index)
    }, line, /*#__PURE__*/_react.default.createElement("br", null))))));
    const progressHead = /*#__PURE__*/_react.default.createElement(_ResultCells.default, {
      item: data,
      resultActions: resultActions,
      shitekiActions: shitekiActions,
      chiefHyokaActions: chiefHyokaActions,
      soshikiShowAll: soshikiShowAll
    });
    return {
      kansaTgtJigyoNmHead,
      kansabumonNmHead,
      hikansabumonNmHead,
      progressHead
    };
  };

  // 検索結果ヘッダ
  const columns = [{
    dataKey: 'kansaTgtJigyoNmHead',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_BUSINESS
    }),
    width: 9
  }, {
    dataKey: 'kansabumonNmHead',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_PROGRESS_AUDITOR
    }),
    width: 9
  }, {
    dataKey: 'hikansabumonNmHead',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_PROGRESS_AUDITEE
    }),
    width: 9
  }, {
    dataKey: 'progressHead',
    label: /*#__PURE__*/_react.default.createElement(_HeaderCells.default, null),
    width: 47
  }];
  return /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
    }),
    rowData: searchResult,
    putTypography: true,
    headerHeight: 90,
    createRow,
    columns,
    paging,
    changeViewNum,
    changePage,
    resetPaging,
    scrollTop,
    onScroll,
    changeCurrentPage: changePage,
    showAll: soshikiShowAll,
    changeShowAll: changeShowAll,
    reload: search
  });
};
KansaResultList.propTypes = {
  searchResult: _propTypes.default.array.isRequired,
  paging: _propTypes.default.shape({
    viewNum: _propTypes.default.number.isRequired,
    currentPage: _propTypes.default.number.isRequired
  }).isRequired,
  resetPaging: _propTypes.default.func.isRequired,
  changePage: _propTypes.default.func.isRequired,
  changeViewNum: _propTypes.default.func.isRequired,
  onScroll: _propTypes.default.func,
  scrollTop: _propTypes.default.shape({
    index: _propTypes.default.number,
    scrollY: _propTypes.default.number,
    noSticky: _propTypes.default.bool
  }),
  onResultReferClick: _propTypes.default.func.isRequired,
  onResultReferOldClick: _propTypes.default.func.isRequired,
  onResultRegistClick: _propTypes.default.func.isRequired,
  onResultUpdateClick: _propTypes.default.func.isRequired,
  onShitekiReferClick: _propTypes.default.func.isRequired,
  onShitekiReferOldClick: _propTypes.default.func.isRequired,
  onShitekiRegistClick: _propTypes.default.func.isRequired,
  onShitekiUpdateClick: _propTypes.default.func.isRequired,
  onChiefHyokaReferClick: _propTypes.default.func.isRequired,
  onChiefHyokaRegistClick: _propTypes.default.func.isRequired,
  onChiefHyokaUpdateClick: _propTypes.default.func.isRequired,
  soshikiShowAll: _propTypes.default.bool.isRequired,
  changeShowAll: _propTypes.default.func.isRequired,
  search: _propTypes.default.bool
};
const mapStateToProps = state => {
  return {
    loginInfo: state.coreLoginInfo,
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    language: state.coreLocale.language,
    search: state.kansaResult.search
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _CodeUtil.withCodeUtil)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(KansaResultList)));